import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { BaseModel } from '~/shared/model'

export default class AgreementsDocumentFile extends BaseModel {
  id: number = 0
  name: string = ''
  fileName: string = ''
  mimeType: string = ''
  source: string = ''

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}
